export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/e53673f1d35014610251dfa259b857bf.png";